/** @format */

import { Navigate, Outlet } from 'react-router-dom';
import { ROUTES } from '../constant/routes';
import { useAuthStore } from '../context/useAuthStore';

const ProtectedRoute: React.FC = () => {
	const { user, isLoading } = useAuthStore();

	if (isLoading) return <div>Loading...</div>;

	return user ? (
		<Outlet />
	) : (
		<Navigate
			to={ROUTES.HOME}
			replace
		/>
	);
};

export default ProtectedRoute;
